module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiYAAAGQAgMAAADn20MgAAAACVBMVEUAKGjvKy3///8STHQSAAABCUlEQVR42u3bMQrAIBBFQc/jadLY5HRpAuIpQ6yENBYLQpxXbjX9Z1OZ6WxvNQ3lfrpLWAcKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKShSlTfalBHehoKCgoKCgoKCgoKBsR5EkSZIkSZIkSZK2y3aIgoKCgoKCgoKCgoKyjOLDDgUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBeV/lAf7DrfMZz4nKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flag/no.png
// module id = 3iKc
// module chunks = 0